// extracted by mini-css-extract-plugin
module.exports = {"main":"MainParts_main__ikLy2","box":"MainParts_box__3-xNa"};